module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.53b66e34.svg";